module.exports = __webpack_public_path__ + "img/1024.0dbfde11.svg";